const initialState = {
    data: {}
};

export const urls = {
    getMonetConfig: '/api/config/package-config'
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'RECEIVE_MONET_CONFIG':
            return {
                ...state,
                data: action.data.data
            };
        default:
            return state;
    }
};
